<template>
<article class="min-h-screen flex flex-col">
    <transition name="component-fade" mode="out-in">
        <div class="container-post container-post__inner pl-8 pr-8 lg1024:pl-0 lg1024:pr-0 lg1024:pb-18"
             v-if="rendered">
            <div v-if="postData">
                <section v-if="newsMessage" class="breadcrumbsContainer py-2">
                    <div class="breadcrumbs row_line">
                        <a href="/">{{ mainPageMessage }}</a>
                        <i class="mdi mdi-chevron-right"></i>
                        <a href="/news/">{{ newsMessage }}</a>
                        <i class="mdi mdi-chevron-right"></i>
                        <template v-if="bindLinkCategory">
                            <a :href="bindLinkCategory">{{ 'category_name' in postData ? postData.category_name : postData.category }}</a>
                            <i class="mdi mdi-chevron-right"></i>
                        </template>
                        <span
                                class="breadcrumbs__current container-post__breadcrumbs"
                                v-html="postData.name"
                        />
                    </div>
                </section>
                <div class="text-left post__heading pt-8 lg1024:pt-16 lg1024:pb-16 lg1024:text-center">
                    <h1 class="font-bebas uppercase text-4xl lg1024:text-5xl leading-none" v-html="postData.name"></h1>
                </div>
                <div class="pt-4">
                    <span class="font-robotoMedium">{{ postData.author ? postData.author : 'Coral Club' }}</span>
                    &bull;
                    <span class="">{{ postData.date }}</span>
                </div>
                <div class="flex flex-wrap justify-between border-b border-themeLightGray pb-4 pt-1 lg1024:pt-0 lg1024:flex-no-wrap">
                    <div class="flex items-center w-full lg1024:w-auto grow">
                        <div class="opacity-075 grow">{{ bindTextLength }}</div>
                        <div class="flex items-center">
                            <img src="../assets/img/views-black.svg">
                            <div class="pl-2 pr-3 text-sm">{{ postData.views }}</div>
                            <Share2 class="pl-3"
                                    :title="postData.name"
                                    :image="`https://ru.coral.club/${postData.detailImageUrl}`"
                                    :description="postData.preview_text"
                            />
                        </div>
                    </div>
                </div>
                <LazyImage
                        v-if="postData.imagePosition === 'TOP' && (postData.detailImageUrl || postData.video)"
                        :alt="postData.name"
                        :classes="['mt-10', 'image-container__post-inner']"
                        :imageUrl="`https://ru.coral.club/${postData.detailImageUrl}`"
                        :video="postData.video"
                />
                <div v-html="postData.detail_text" class="post-text text-xl pt-6 lg1024:pt-9"></div>
                <LazyImage
                        v-if="postData.imagePosition === 'BOTTOM' && (postData.detailImageUrl || postData.video)"
                        :alt="postData.name"
                        :classes="['image-container__post-inner']"
                        :imageUrl="`https://ru.coral.club/${postData.detailImageUrl}`" :video="postData.video"
                />
            </div>
            <div class="flex justify-center relative mt-20" v-else>{{ getErrorMessage() }}</div>
        </div>
        <div class="min-h-screen flex justify-center relative" v-else>
            <Loader/>
        </div>
    </transition>

    <nav class="post-footer-navigation pr-8 pl-8 lg1024:pl-0 lg1024:pr-0" v-if="rendered && postData">
        <div class="container-post flex justify-between">
            <router-link :to="{ name: 'Post', params: { id: previousPost.id, code: previousPost.code }}"
                         class="w-full lg1024:w-1/3">
                <img src="../assets/img/previous-arrow.svg" class="pt-8 lg1024:pt-12">
                <div class="text-md font-medium pr-4 lg1024:text-2xl pt-2 pb-8 lg1024:text-lg lg1024:pb-20 lg1024:pr-0"
                     v-html="removeTags(previousPost.name)"/>
            </router-link>
            <router-link :to="{ name: 'Post', params: { id: nextPost.id, code: nextPost.code }}"
                         class="w-full lg1024:w-1/3" v-if="nextPost">
                <img src="../assets/img/next-arrow.svg" class="pt-8 lg1024:pt-12">
                <div class="text-md font-medium lg1024:text-2xl pt-2 pb-8 lg1024:pb-20 lg1024:text-lg"
                     v-html="removeTags(nextPost.name)"/>
            </router-link>
        </div>
    </nav>
</article>

</template>
<script>
import LazyImage from './LazyImage'
import Loader from './Loader'
import Share2 from './Share2'

export default {
  name: 'Post',
  components: {
    Share2,
    LazyImage,
    Loader
  },
  data () {
    return {
      code: undefined,
      postData: {},
      previousPost: {},
      nextPost: {},
      rendered: false,
    }
  },
  computed: {
    newsMessage () {
      return this.$store.getters.getTranslation('news')
    },
    mainPageMessage () {
      return this.$store.getters.getTranslation('main_page')
    },
    bindLink () {
      return `/news/posts/${this.code}/`
    },
    bindLinkCategory () {
      let id = this.postData !== undefined && ('category_id' in this.postData)
        ? this.postData['category_id']
        : undefined

      switch (id) {
        case 269:
        case '269':
          return `/news/smi/`
        default:
          return null
      }
    },
    bindDateMinute () {
      return new Intl.DisplayNames(
        document.querySelector('html').lang,
        { type: 'dateTimeField' }
      ).of('minute')
    },
    bindTextLength () {
      const text = this.$store.getters.getTranslation('minute_reading')
      return text && text !== '' && text !== ' '
        ? Math.round(this.postData.detail_text.length / 1500).toString() + ` ${text}`
        : ''
    }
  },
  updated () {
    document.querySelector('title').innerText = 'title' in this.postData
      ? this.postData.title
      : this.postData.name
    document.querySelector('meta[name="description"]').setAttribute(
      'content',
      'description' in this.postData
        ? this.postData.description
        : this.postData.preview_text
    )
  },
  methods: {
    getLink () {
      if (this.postData.link.match(/\//)) {
        let link = this.postData.link
        let offer = this.postData.link.match(/offer=([0-9]+)/)?.[1]

        link += this.postData.link.match(/\?/) ? '&' : '?'
        link += 'analytics=news_product&code='
        link += this.postData.link.match(/shop\/([^.]+)\.html/)?.[1]
        link += offer ? `_${offer}` : ''

        return link
      } else {
        return `/shop/${this.postData.link}.html?analytics=news_product&code=${this.postData.link}`
      }
    },
    getErrorMessage () {
      return this.$store.getters.getTranslation('post_not_found')
    },
    getLinkMessage () {
      return this.$store.getters.getTranslation(this.postData?.['link_text'] || 'buy')
    },
    isMobile () {
      return /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent)
    },
    async getPostData () {
      this.postData = this.$store.getters.getPost(this.code)

      if (!this.postData) {
        await this.$store.dispatch('GET_POSTS')
        await this.$store.dispatch('GET_POST', this.code)
        this.postData = this.$store.getters.getPost(this.code)
        if (!this.postData) {
          this.rendered = true
        }
      } else if (!this.postData.detail_text) {
        await this.$store.dispatch('GET_POST', this.code)
        this.postData = this.$store.getters.getPost(this.code)

      } else {
        this.$store.commit('changeCurrentUrl', this.postData.category)
      }
      if (this.postData) {
        this.getPreviousPost()
        this.getNextPost()
      }
    },
    getPreviousPost () {
      return this.previousPost = this.$store.getters.getPreviousPost(this.postData.id)
    },
    getNextPost () {
      this.nextPost = this.$store.getters.getNextPost(this.postData.id)
      return this.nextPost
    },
    removeTags (string) {
      return string.replace(/<\/?[^>]+>/ig, ' ')
    },
  },
  watch: {
    '$route.params.code': {
      async handler (newValue) {
        this.rendered = false
        window.scrollTo(0, 0)
        this.code = newValue
        await this.getPostData()
        this.rendered = true
      },
      immediate: true,
    }
  },
}
</script>

<style>
blockquote p:first-child {
    margin-left: 3rem;
}

blockquote:before {
    content: url(../assets/img/quotes.svg);
    position: relative;
    top: 2.3rem;
}

blockquote {
    max-width: 80%;
    background: none;
    border-left: none;
    padding: 1rem;
    color: #252631;
    margin-left: 10%;
}

blockquote p {
    opacity: 0.75;
    font-size: 2rem;
    margin-left: 3rem;
    padding-bottom: 0;
    line-height: 1.25 !important;
}

blockquote p:not(:only-child):last-child {
    font-size: 14px;
    font-weight: 600;
    text-transform: uppercase;
    opacity: 1;
    margin-left: 3rem;
    position: relative;
    bottom: 5px;
}

blockquote p:not(:only-child):last-child:before {
    content: "—";
}

.container-post__inner img {
    width: 100% !important;
}

.post-footer-navigation {
    background-color: #FAFAFA;
    margin-top: auto;
}

.post-text {
    padding-bottom: 3rem;
}

.post-text p {
    line-height: 32px;
    padding-bottom: 1.5rem;
}

.post-text h2, .post-text h3, .post-text h4, .post-text h5, .post-text h6 {
    font-family: Roboto, Arial, sans-serif;
    line-height: 1.25;
    max-width: 80%;
}

.post-text h2 {
    font-size: 2.5rem;
    padding-top: 2rem;
    padding-bottom: 1.5rem;
    line-height: 2.5rem;
    max-width: 80%;
    font-weight: 700;
}

.post-text h3 {
    font-size: 2rem;
    padding-bottom: 1.5rem;
    font-weight: 500
}

.post-text h4 {
    font-size: 1.5rem;
    padding-bottom: 1.25rem;
    font-weight: 500
}

.post-text h5, .post-text h6 {
    font-size: 1rem;
    font-weight: 700;
}

.post-text h6 {
    text-transform: uppercase;
}

.image-container__post-inner {
    width: 100%;
}

@media only screen and (max-width: 449px) {
    .image-container__post-inner {
        height: 215px;
    }
}

@media only screen and (min-width: 450px) and (max-width: 767px) {
    .image-container__post-inner {
        height: 300px;
    }

    blockquote {
        font-size: 1em;
    }
}


@media only screen and (min-width: 768px) and (max-width: 1023px) {
    .image-container__post-inner {
        height: 357px;
    }
}

@media only screen and (min-width: 1024px) and (max-width: 1279px) {
    .image-container__post-inner {
        height: 478px;
    }
}

@media only screen and (min-width: 1280px) and (max-width: 1919px) {
    .image-container__post-inner {
        height: 610px;
    }
}

@media only screen and (min-width: 1919px) {
    .image-container__post-inner {
        height: 650px;
    }

}

.container-post__breadcrumbs {
    max-width: 100%;
    width: 240px;
    text-overflow: ellipsis;
    overflow: hidden;
    white-space: nowrap;
    display: inline-block;
}

.grow {
    flex-grow: 1;
}
</style>
